import { Model, attr } from '@elatonsev/js-models';

export default class PhotoModel extends Model {
  src = attr('string');
  thumb_src = attr('string');
}